import { videoPlayer } from '@store/index'
import { useSetRecoilState, useResetRecoilState, useRecoilValue } from 'recoil'
import { useCallback } from 'react'

export default function useVideoPlayer() {

  const state = useRecoilValue(videoPlayer)
  const setVideoPlayerState = useSetRecoilState(videoPlayer)
  const resetVideoPlayerState = useResetRecoilState(videoPlayer)

  // 显示视频播放器
  const showVideoPlayer = useCallback(({ url }) => {
    return event => {
      event.preventDefault()
      event.stopPropagation()
      setVideoPlayerState(d => ({ ...d, show: true, url }))
    }
  }, [setVideoPlayerState])

  // 隐藏视频播放器
  const hideVideoPlayer = useCallback(() => {
    resetVideoPlayerState()
  }, [resetVideoPlayerState])

  return {
    ...state,
    showVideoPlayer,
    hideVideoPlayer
  }
}